import Base from './Base';

class Request extends Base {

    constructor(token) {
        super(token);
        this.endpoint = 'requests';
    }

    resendEmail(id) {
        return fetch(this.getUrlEndpoint("notify/" + id), {
            method: 'GET',
            headers: this.headers
        }).then(response => response.json())
    }

    sendWhatsEmail(id) {
        return fetch(this.getUrlEndpoint("notify/whatsapp/" + id), {
            method: 'GET',
            headers: this.headers
        }).then(response => response.json())
    }

    reinitTimer(id) {
        return fetch(this.getUrlEndpoint("reinitialize-timer/" + id), {
            method: 'GET',
            headers: this.headers
        }).then(response => response.json())
    }

    sendContract(id, data) {
        return fetch(this.getUrlEndpoint("enviar-contrato/" + id), {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then(response => response.json())
    }

    createEmpty(data) {
        return fetch(this.getUrlEndpoint("create-empty"), {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then(response => response.json())
    }

    confirmPickup(id, data) {
        return fetch(this.getUrlEndpoint("confirm-pickup/" + id), {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then(response => response.json())
    }

    checkConfirmation(id) {
        return fetch(this.getUrlEndpoint("check/" + id), {
            method: 'GET',
            headers: this.headers
        }).then(response => response.json())
    }

    getImages(request_id) {
        return fetch(this.getUrlEndpoint("getImages/" + request_id), {
            method: 'GET',
            headers: this.headers
        }).then(response => response.json())
    }

}

export default Request;